import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class ComponentName extends React.Component {
  static propTypes = {
    orderBy: PropTypes.func,
    renderArrows: PropTypes.func
  }
  render() {
    const { orderBy, renderArrows } = this.props
    return (
      <div className={styles.container}>
        <div onClick={() => orderBy('code')} className={styles.market}>
          Mercado
          {renderArrows('code')}
        </div>
        <div onClick={() => orderBy('price')} className={styles.price}>
          Precio
          {renderArrows('price')}
        </div>
        <div onClick={() => orderBy('variation')} className={styles.variation}>
          Variación (24H)
          {renderArrows('variation')}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Header/Mobile/index.js